// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabs_container__uBlTR {
  display: flex;
  margin-bottom: 20px;
  padding-left: 10px;
  position: relative;
  border-bottom: none;
  box-sizing: border-box; }
  .tabs_container__uBlTR .tabs_container_underline__p9Exd {
    flex-grow: 1;
    border-bottom: 1px solid var(--Gray85); }
    .tabs_container__uBlTR .tabs_container_underline__p9Exd::marker {
      color: transparent; }

.tabs_tab__Kge9L {
  min-width: 122px;
  position: relative;
  padding: 10px 20px;
  list-style-type: none;
  cursor: pointer;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
  box-sizing: border-box;
  border: 1px solid transparent; }
  .tabs_tab_active__FM2CG {
    border: 1px solid var(--LowEmphasis);
    border-radius: 4px 4px 0px 0px;
    border-bottom: none; }
  .tabs_tab_nonActive__ufHgY {
    color: #9E9E9E;
    border-bottom: 1px solid var(--Gray85); }
`, "",{"version":3,"sources":["webpack://./src/pages/camera/modal/tabs/tabs.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB,EAAA;EANxB;IASI,YAAY;IACZ,sCAAsC,EAAA;IAV1C;MAaM,kBAAkB,EAAA;;AAKxB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,6BAA6B,EAAA;EAC7B;IACE,oCAAoC;IACpC,8BAA8B;IAC9B,mBAAmB,EAAA;EAGrB;IACE,cAAa;IACb,sCAAsC,EAAA","sourcesContent":["@import '../../../../styles/media.scss';\n@import '../../../../styles/fonts.scss';\n\n.container {\n  display: flex;\n  margin-bottom: 20px;\n  padding-left: 10px;\n  position: relative;\n  border-bottom: none;\n  box-sizing: border-box;\n\n  .container_underline {\n    flex-grow: 1;\n    border-bottom: 1px solid var(--Gray85);\n\n    &::marker {\n      color: transparent;\n    }\n  }\n}\n\n.tab {\n  min-width: 122px;\n  position: relative;\n  padding: 10px 20px;\n  list-style-type: none;\n  cursor: pointer;\n  text-align: center;\n  user-select: none;\n  box-sizing: border-box;\n  border: 1px solid transparent;\n  &_active {\n    border: 1px solid var(--LowEmphasis);\n    border-radius: 4px 4px 0px 0px;\n    border-bottom: none;\n    }\n\n  &_nonActive {\n    color:#9E9E9E;\n    border-bottom: 1px solid var(--Gray85);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `tabs_container__uBlTR`,
	"container_underline": `tabs_container_underline__p9Exd`,
	"tab": `tabs_tab__Kge9L`,
	"tab_active": `tabs_tab_active__FM2CG`,
	"tab_nonActive": `tabs_tab_nonActive__ufHgY`
};
export default ___CSS_LOADER_EXPORT___;
